// extracted by mini-css-extract-plugin
export default {"homepage":"Account_homepage__JHIo8"};